import React, { useState, useEffect, useRef, Fragment } from "react";

import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import AdminDashboardDataService from "../../../services/admin-dashboard.service";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import communityVendorService from "../../../services/community-vendor.service";
import CommunityInventoryService from "../../../services/community-inventory.service";
import RetailerDataService from "../../../services/retailer-retailer.service";
import { useSelector } from "react-redux";
import space__icon from "../../../assets/images/space__icon.png";
import StarRatings from "react-star-ratings";
import Filter_icon from "../../../assets/images/filter_icon.png";
import Info_icon from "../../../assets/images/info_icon.png";
import Close from "../../../assets/images/close.png";
import NotificationManager from "react-notifications/lib/NotificationManager";
import {
  Button,
  Checkbox,
  Input,
  Modal,
  Pagination,
  Select,
  Slider,
  Spin,
  Switch,
  Table,
  Tooltip,
} from "antd";

const ManageInventory = () => {
  const { t } = useTranslation();
  // inventory
  const [checked, setChecked] = useState(false);
  const [productChange, setProductChange] = useState(true);
  const [viewItem, setViewItem] = useState("list");
  const [hideShowFilter, setHideShowFilter] = useState(false);
  const [visibleAll, setVisibleAll] = useState(false);
  // For bindActive
  const search = useLocation().search;
  const paramIsShow = new URLSearchParams(search).get("isShow");
  const bindActivePage = useSelector(
    (state) => state.manageInventoryReducer.bindActivePageName
  );

  const [data, setData] = useState([]);
  const [columns, setColumns] = useState(() => buildColumns(false)); // start hidden

  function onSearch(val) {}

  const handleHideShowFilter = () => {
    setHideShowFilter(!hideShowFilter);
  };

  const handleViewChange = (viewname) => {
    setBindWhatVal("Products");
    handleGetOneVendorProduct(
      dealerId,
      vendorId,
      "Products",
      searchValue,
      ManageInventoryState.priceMax == priceValue[1] ? [0, 0] : priceValue,
      pageNo,
      pageSize
    );
    setViewItem(viewname);
  };

  /*Custom State Binding Starts*/
  const initialManageInventoryState = {
    productType: [],
    category: [],
    collection: [],
    metalType: [],
    metalColor: [],
    priceMin: 0,
    priceMax: "",
    gemstoneType: [],
  };
  const { Search } = Input;
  const [ManageInventoryState, setManageInventoryState] = useState(
    initialManageInventoryState
  );
  const [ProductTypeList, setProductTypeList] = useState([]);
  const [CategoriesList, setCategoriesList] = useState([]);
  const [MetalTypeList, setMetalTypeList] = useState([]);
  const [MetalColorList, setMetalColorList] = useState([]);
  const [CollectionList, setCollectionList] = useState([]);
  const [GemstoneList, setGemstoneList] = useState([]);
  const [priceValue, setPriceValue] = useState([0, 0]);
  const [rowDetails, setRowDetails] = useState({});
  const [bindWhatVal, setBindWhatVal] = useState("ALL");
  const [imagePath, setImagePath] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [sortType, setSortType] = useState("asc");
  const [sortColumnName, setSortColumnName] = useState("GFInventoryID");
  const [vendorProductList, setVendorProductList] = useState([]);
  const [vendorProductDetail, setVendorProductDetail] = useState([]);
  const [selectedgfInventoryID, setSelectedgfInventoryID] = useState(0);
  const [productTotalRecords, setProductTotalRecords] = useState(0);
  const [IsRestricted, setIsRestricted] = useState(0);
  const [checkHidePrice, setCheckHidePrice] = useState("");
  const [loading, setLoading] = useState(true);

  const [searchValue, SetSearchValue] = useState("");
  const [activeProductIds, setActiveProductIds] = useState([]);
  const [inActiveProductIds, setInActiveProductIds] = useState([]);
  const [activeDeactiveAll, setActiveDeactiveAll] = useState("");
  const [updateFlagLoading, setUpdateFlagLoading] = useState(false);
  const [IsFirstCall, setIsFirstCall] = useState(true);
  const [visibleImagePreview, setVisibleImagePreview] = useState(false);
  const [visibleEmailModal, setVisibleEmailModal] = useState(false);
  const [loadOnce, setLoadOnce] = useState("");

  const [isModalSendInvitationVisible, setIsModalSendInvitationVisible] =
    useState(false);
  /*Custom State Binding Ends*/

  //inventory ends
  const { Option } = Select;
  const [selectedTab, setSelectedTab] = useState("Profile");
  const [dealerId, setDealerId] = useState("");
  const [loginDealerId, setLoginDealerId] = useState("");
  const [visible, setVisible] = useState(false);
  const [sideProfileLoading, setSideProfileLoading] = useState(false);
  const [retailerId, setRetailerId] = useState("");
  const [selectedColumnId, setSelectedColumnId] = useState(0);
  const [company, setCompany] = useState("");
  const [content, setContent] = useState("");
  const [emailModalContent, setEmailModalContent] = useState("");
  const [emailLoading, setEmailLoading] = useState(false);
  const [page, setPage] = useState("RetailerAffirmation");
  const [checkbox, setCheckBox] = useState("");
  const [conversationData, setConversationData] = useState([]);
  const [conversationLoading, setConversationLoading] = useState(false);
  const [conversationMsg, setConversationMsg] = useState("");
  const hasFetched = useRef(false);
  const [
    dashBoardVendorLeftPanelInfoList,
    setDashBoardVendorLeftPanelInfoList,
  ] = useState({});
  const [validations, setValidations] = useState({
    conversationVal: "",
    tradeshowVal: "",
    salesRepVal: "",
    appointmentDateVal: "",
    buyerNameVal: "",
    emailAddressVal: "",
    phoneNumberVal: "",
    qncVal: "",
    timeval: "",
  });
  const [appointmentData, setAppointmentData] = useState({
    tradeshow: "",
    salesRep: "",
    appointmentDate: "",
    appointmentTime: "",
    buyerName: "",
    emailAddress: "",
    phoneNumber: "",
    preferred: "E-Mail",
    qnc: "",
    interested: false,
  });
  const [SalesRep, setSalesRep] = useState([]);
  const [contentLoading, setContentLoading] = useState(false);
  const [tradeShowList, setTradeShowList] = useState([]);
  const [contentAppData, setContentAppData] = useState("");
  const category = [
    {
      label: t("Current Authorized Resellers"),
      value: "CurrentAuthorizedReseller",
      note: (
        <>
          {t(
            "By checking this box and clicking the submit button below Ihere by affirm that"
          )}
          {company ? company : null}
          {t("has an open and active account with")}
          {rowDetails.DesignerName ? rowDetails.DesignerName : ""}
          {t(",that I am an authorized reseller of")}
          {rowDetails.DesignerName ? rowDetails.DesignerName : ""}
          {t(
            ",and that I am permitted to have the ir virtual inventory on my website."
          )}
        </>
      ),
    },
    {
      label: t("New Account Request"),
      value: "NewAccountRequest",
      note: (
        <>
          {t("I am interested in opening a new account with")}{" "}
          {rowDetails.DesignerName ? rowDetails.DesignerName : ""}{" "}
          {t(
            "and becoming an authorized reseller.By checking this box and clicking the submit button below, your name and store information will be sent to"
          )}
          {rowDetails.DesignerName ? rowDetails.DesignerName : ""}.
        </>
      ),
    },
  ];
  const loginDetials = useSelector((state) => state.loginReducer);
  const location = useLocation();
  const currency = useSelector((state) => state.loginReducer.currency);
  const currencySymbol = currency ? currency.charAt(currency.length - 1) : "$";
  const vendorId = useSelector(
    (state) => state.manageInventoryReducer.vendorId
  );

  const [QuickLinksLoading, setQuickLinksLoading] = useState(false);
  const [vendorMembershipType, setVendorMembershipType] = useState("");

  useEffect(() => {
    if (hasFetched.current) return;

    hasFetched.current = true;
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          setVendorMembershipType(loginDetials.loginDetials.responseData.dealerMemberTypeName);
          setLoginDealerId(loginDetials.loginDetials.responseData.dealerId);
          setCompany(loginDetials.loginDetials.responseData.dealerCompany);
          GetSalesRepsList(loginDetials.loginDetials.responseData.dealerId);
          handleGetTradeShowAppointment(
            loginDetials.loginDetials.responseData.dealerId
          );
          handleGetDashBoardVendorLeftPanelInfo(
            loginDetials.loginDetials.responseData.dealerId
          );

          setRetailerId(vendorId);
          if (location.state) {
            /*handleGetOneVendorProductOnSelect(
              loginDetials.loginDetials.responseData.dealerId,
              "",
              location.state.id
            );*/

            handleGetOneVendorProduct(
              loginDetials.loginDetials.responseData.dealerId,
              location.state.id,
              bindWhatVal,
              searchValue,
              priceValue,
              pageNo,
              pageSize,
              sortColumnName,
              sortType
            );
            handleLoadLeftRightSideData(
              loginDetials.loginDetials.responseData.dealerId,
              location.state.id
            );
          } else {
            setLoadOnce("Load");
            /*handleGetOneVendorProductOnSelect(
              loginDetials.loginDetials.responseData.dealerId,
              "",
              vendorId
            );*/
            handleGetOneVendorProduct(
              loginDetials.loginDetials.responseData.dealerId,
              vendorId,
              bindWhatVal,
              searchValue,
              priceValue,
              pageNo,
              pageSize,
              sortColumnName,
              sortType
            );
            handleLoadLeftRightSideData(
              loginDetials.loginDetials.responseData.dealerId,
              vendorId
            );
          }
        }
      }
    }
  }, []);

  // Update columns when checkHidePrice changes to fix the price display issue
  useEffect(() => {
    if (rowDetails && Object.keys(rowDetails).length > 0) {
      const showIsActive =
        (rowDetails.Status == "Connected" &&
          rowDetails.VendorStatus == "Active") ||
        rowDetails.DealerID == dealerId;
      setColumns(buildColumns(showIsActive));
      console.log(
        "Columns updated due to checkHidePrice change:",
        checkHidePrice
      );
    }
  }, [checkHidePrice, rowDetails, dealerId]);

  // Define buildColumns function before it's used
  function buildColumns(showIsActive) {
    const cols = [
      {
        title: "",
        dataIndex: "imagepath",
        width: "40px",
        showSorterTooltip: false,
        render: (item, row) => (
          <img
            src={row.imagepath || ""}
            className="prod__img"
            width="20px"
            alt=""
            onClick={() => {
              setVisibleImagePreview(true);
              setImagePath(row.imagepath);
            }}
          />
        ),
      },
      {
        title: "",
        dataIndex: "view",
        width: "40px",
        showSorterTooltip: false,
        render: (item, row) => (
          <div
            className="infoicon__div"
            onClick={() => handleOpenDetailsModal(row)}
          >
            <i className="fa fa-info-circle linkText" />
          </div>
        ),
      },

      // Conditionally include IsActive column
      ...(showIsActive
        ? [
            {
              title: <Tooltip title={t("Active")}>{t("Active")}</Tooltip>,
              ellipsis: true,
              showSorterTooltip: false,
              dataIndex: "IsActive",
              render: (item, row) => (
                <Switch
                  checkedChildren={t("Yes")}
                  unCheckedChildren={t("No")}
                  checked={row.IsActive}
                  onChange={(checked) => {
                    handleToggleOnChange(checked, row.GFInventoryID);
                  }}
                />
              ),
            },
          ]
        : []),

      {
        title: <Tooltip title={t("SKU")}>{t("SKU")}</Tooltip>,
        ellipsis: true,
        showSorterTooltip: false,
        dataIndex: "SKU",
        width: "180px",
        sorter: (a, b) => {},
        render: (item, row) => <span>{row.SKU}</span>,
      },
      {
        title: <Tooltip title={t("Category")}>{t("Category")}</Tooltip>,
        ellipsis: true,
        showSorterTooltip: false,
        dataIndex: "CategoryFormated",
        width: "180px",
        sorter: (a, b) => {},
        render: (item, row) => <span>{row.CategoryFormated}</span>,
      },
      {
        title: <Tooltip title={t("Metal Type")}>{t("Metal Type")}</Tooltip>,
        ellipsis: true,
        showSorterTooltip: false,
        dataIndex: "MetalTypeFormated",
        sorter: (a, b) => {},
        render: (item, row) => <span>{row.MetalTypeFormated || " - "}</span>,
      },
      {
        title: <Tooltip title={t("Metal Color")}>{t("Metal Color")}</Tooltip>,
        ellipsis: true,
        showSorterTooltip: false,
        dataIndex: "MetalColorFormated",
        sorter: (a, b) => {},
        render: (item, row) => <span>{row.MetalColorFormated || " - "}</span>,
      },
      {
        title: <Tooltip title={t("MSRP")}>{t("MSRP")}</Tooltip>,
        ellipsis: true,
        showSorterTooltip: false,
        dataIndex: "MSRP",
        sorter: (a, b) => {},
        render: (item, row) => {
          // Handle case where checkHidePrice might be empty string initially
          const shouldHidePrice =
            checkHidePrice === "true" ||
            checkHidePrice === "1" ||
            checkHidePrice === 1;
          return (
            <span>
              {shouldHidePrice
                ? " - "
                : row.MSRP && row.MSRP !== "0" && row.MSRP !== 0 && row.MSRP !== "-"
                ? row.CurrenySymbol + " " + row.MSRP
                : " - "}
            </span>
          );
        },
      }
    ];

    return cols;
  }

  const handleGetDashBoardVendorLeftPanelInfo = async (id) => {
    setQuickLinksLoading(true);
    try {
      let inputData = {
        dealerId: id.toString(),
      };
      await AdminDashboardDataService.GetDashBoardVendorLeftPanelInfo(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var dashBoardVendorLeftPanelInfoList = responseData;
          if (message === "Success") {
            setQuickLinksLoading(false);
            if (responseData) {
              setDashBoardVendorLeftPanelInfoList(
                dashBoardVendorLeftPanelInfoList
              );
            } else {
              setDashBoardVendorLeftPanelInfoList();
            }
          } else {
            setDashBoardVendorLeftPanelInfoList();
          }
        })
        .catch((error) => {
          console.log(error);
          setQuickLinksLoading(false);
        });
    } catch (error) {
      console.log(error);
      setQuickLinksLoading(false);
    }
  };

  const handleGetTradeShowAppointment = (id) => {
    try {
      let inputData = {
        dealerID: id,
      };
      communityVendorService
        .TradeShowAppointment(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData) {
              setTradeShowList(responseData);
            } else {
              setTradeShowList([]);
            }
          } else {
            setTradeShowList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const GetSalesRepsList = (id) => {
    try {
      let inputData = {
        dealerID: id,
      };
      RetailerDataService.GetSalesRepsList(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData) {
              setSalesRep(responseData);
            } else {
              setSalesRep([]);
            }
          } else {
            setSalesRep([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleLoadVendorConversation = (dealerid, id) => {
    try {
      let inputData = {
        vendorID: id,
        dealerID: dealerid,
      };
      setConversationLoading(true);
      communityVendorService
        .LoadVendorConversation(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData) {
              setConversationData(responseData);
              setConversationLoading(false);
            } else {
              setConversationLoading(false);
              setConversationData([]);
            }
          } else {
            setConversationLoading(false);
            setConversationData([]);
          }
        })
        .catch((error) => {
          console.log(error);
          setConversationLoading(false);
        });
    } catch (error) {
      console.log(error);
      setConversationLoading(false);
    }
  };

  const handleLoadLeftRightSideData = (id, retailerID) => {
    try {
      let inputData = {
        dealerID: id.toString(),
        vendorId: retailerID.toString(),
        f_Type: "1",
      };
      setSelectedColumnId(retailerID);
      setSideProfileLoading(true);
      CommunityInventoryService.LoadLeftRightSideData(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setRowDetails(responseData.Table[0]);
              setSideProfileLoading(false);
            } else {
              setRowDetails({});
              setSideProfileLoading(false);
            }
          } else {
            setRowDetails({});
            setSideProfileLoading(false);
          }
          setTimeout(() => {
            if (responseData.Table[0]) {
              setColumns(
                buildColumns(
                  (responseData.Table[0].Status == "Connected" &&
                    responseData.Table[0].VendorStatus == "Active") ||
                    responseData.Table[0].DealerID == id
                    ? true
                    : false
                )
              );
            }
          }, 0);
        })
        .catch((error) => {
          console.log(error);
          setSideProfileLoading(false);
        });
    } catch (error) {
      console.log(error);
      setSideProfileLoading(false);
    }
  };

  const handleSendInvitationModalCancel = () => {
    setIsModalSendInvitationVisible(false);
    setPage("RetailerAffirmation");
    setCheckBox("");
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleCancelWarning = () => {
    setVisibleAll(false);
  };

  function onSearch(val) {}
  const onSearchFunc = (value) => {
    SetSearchValue(value);
    handleGetOneVendorProduct(
      loginDetials.loginDetials.responseData.dealerId,
      vendorId,
      bindWhatVal,
      value,
      priceValue,
      1,
      15,
      sortColumnName,
      sortType
    );
    setPageNo(1);
    setPageSize(15);
  };

  function handleCheckBoxChange(checkedValues) {
    setCheckBox(checkedValues.target.value);
  }

  const handleShowEmailWindow = () => {
    setPage("SendEmail");
    handleGetEmailData();
  };

  const handleGetEmailData = () => {
    try {
      let inputData = {
        vendorID: retailerId,
        designerType: 3,
        dealerID: dealerId,
        emailType: rowDetails.emailType,
      };
      setEmailLoading(true);
      CommunityInventoryService.GeneratePopupForAffirmation(inputData)
        .then((response) => {
          setEmailLoading(false);
          let message = response.data.message;
          let responseData = response.data.responseData.sendMsgBody;
          if (message === "Success") {
            if (responseData) {
              setContent(responseData);
            }
          } else {
            setContent([]);
          }
        })
        .catch((error) => {
          console.log(error);
          setEmailLoading(false);
        });
    } catch (error) {
      console.log(error);
      setEmailLoading(false);
    }
  };
  const handleGeneratePopup = (dealerId) => {
    try {
      let inputData = {
        vendorID: retailerId,
        designerType: 3,
        dealerID: dealerId,
        emailType: rowDetails.emailType,
        userName: "Alex Fetanat",
      };

      CommunityInventoryService.GeneratePopup(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData) {
              setEmailModalContent(responseData);
            }
          } else {
            setEmailModalContent([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleCheckBoxValidation = () => {
    NotificationManager.error(t("Please select option"));
  };
  const handleNewAccountRequest = () => {
    try {
      let inputData = {
        email_Type: rowDetails.emailType,
        vendorID: retailerId,
        dealerID: dealerId,
      };

      communityVendorService
        .SendEmailToAllEmailType(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData.sendMsgBody;
          if (message === "Success") {
            setContent(responseData);
            NotificationManager.success(t("Request sent Successfully"));
          } else {
            setContent([]);
            NotificationManager.error(t("Something went wrong"));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
    handleSendInvitationModalCancel();
  };

  const handleSendEmail = () => {
    try {
      let inputData = {
        editval: content,
        email_Type: rowDetails.emailType,
        vendorID: retailerId,
        dealerID: dealerId,
      };

      communityVendorService
        .SendEmailToVendor(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData.sendMsgBody;

          if (message === "Success") {
            NotificationManager.success(t("Email has been sent Successfully"));
            setContent(responseData);
          } else {
            NotificationManager.success(t("Email has not been sent"));
            setContent([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
    handleSendInvitationModalCancel();
  };

  const handleValidation = () => {
    const validations = {
      conversationVal: "",
      appointmentVal: "",
      tradeshowVal: "",
      appointmentDateVal: "",
      buyerNameVal: "",
      emailAddressVal: "",
      phoneNumberVal: "",
      qncVal: "",
      timeval: "",
    };

    let isValid = true;
    if (selectedTab == "Conversation") {
      if (!conversationMsg.trim()) {
        isValid = false;
        validations.conversationVal = t("Conversation data is compulsory");
      }
    }

    if (selectedTab == "Appointments") {
      if (tradeShowList.length !== 0) {
        if (!appointmentData.tradeshow) {
          isValid = false;
          validations.tradeshowVal = t("Trade show is compulsory");
        }
      }
      if (!appointmentData.salesRep) {
        isValid = false;
        validations.salesRepVal = t("Sales rep is compulsory");
      }
      if (!appointmentData.appointmentDate) {
        isValid = false;
        validations.appointmentDateVal = t("Appointment date is compulsory");
      }
      if (!appointmentData.buyerName) {
        isValid = false;
        validations.buyerNameVal = t("Buyer name is compulsory");
      }
      let validRegex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!appointmentData.emailAddress.trim()) {
        isValid = false;
        validations.emailAddressVal = t("Email address is compulsory");
      } else if (!appointmentData.emailAddress.match(validRegex)) {
        isValid = false;
        validations.emailAddressVal = t("Email address is invalid");
      } else {
        validations.emailAddressVal = "";
      }
      if (!appointmentData.phoneNumber.trim()) {
        isValid = false;
        validations.phoneNumberVal = t("Phone number is compulsory");
      } else if (
        (appointmentData.phoneNumber.length >= 10 &&
          appointmentData.phoneNumber.includes("-")) ||
        (appointmentData.phoneNumber.length >= 10 &&
          appointmentData.phoneNumber.includes(",")) ||
        (appointmentData.phoneNumber.length >= 10 &&
          appointmentData.phoneNumber.includes("+"))
      ) {
        validations.phoneNumberVal = "";
      } else if (
        !/^(?!0{10,15})(\+\d{1,3}[-]?)?\d{10,15}$/.test(
          appointmentData.phoneNumber
        )
      ) {
        isValid = false;
        validations.phoneNumberVal = t("Phone number is invalid");
      } else {
        validations.phoneNumberVal = "";
      }
      if (!appointmentData.qnc) {
        isValid = false;
        validations.qncVal = t("Question is compulsory");
      }
      if (!appointmentData.appointmentTime) {
        isValid = false;
        validations.timeval = t("Time is compulsory");
      }
    }

    if (!isValid) {
      setValidations(validations);
    }

    return isValid;
  };

  const handleSendEmailCancel = () => {
    setVisibleEmailModal(false);
  };

  const handleSendEmailDetails = () => {
    try {
      let inputData = {
        dealerShowID: "",
        dealerID: dealerId.toString(),
        vendorID: selectedColumnId.toString(),
        appintmentDate: appointmentData.appointmentDate,
        appointmentTime: appointmentData.appointmentTime,
        buyerName: appointmentData.buyerName,
        email: appointmentData.emailAddress,
        phoneNumber: appointmentData.phoneNumber,
        questionsAndComments: appointmentData.qnc,
        boothNumber: appointmentData.tradeshow,
        editHTML: contentAppData,
        preferred: appointmentData.preferred,
        localRep: appointmentData.salesRep,
        placingInventory: appointmentData.interested == true ? 1 : 0,
      };
      communityVendorService
        .InsertVendorsAppointment(inputData)
        .then((response) => {
          let message = response.data.message;
          if (message === "Success") {
            NotificationManager.success(t("Appointement added Successfully."));
            handleLoadVendorConversation(dealerId, selectedColumnId);
          } else {
            NotificationManager.error(t("Appointement not Added."));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const openInNewTab = () => {
    let url = rowDetails.website;
    if (rowDetails.website.includes("https")) {
      window.open(url, "_blank");
    } else if (rowDetails.website.includes("http")) {
      window.open(url, "_blank");
    } else {
      window.open("https://" + url, "_blank");
    }
  };

  /*Custom API Binding Starts*/
  //console.log(5);
  const handleGetOneVendorProduct = (
    dealerID,
    vendorId,
    bindWhatVal,
    searchValue,
    priceValue,
    pageNo,
    pageSize,
    sortColumnName,
    sortOrder
  ) => {
    try {
      let inputData = {
        //bindWhat: bindWhatVal ? bindWhatVal : "ALL",
        bindWhat: "ALL",
        dealerID: dealerID ? dealerID.toString() : "",
        vendorId: vendorId ? vendorId.toString() : "",
        collection:
          ManageInventoryState.collection.length > 0
            ? ManageInventoryState.collection.toString()
            : "",
        productType:
          ManageInventoryState.productType.length > 0
            ? ManageInventoryState.productType.toString()
            : "",
        metalType:
          ManageInventoryState.metalType.length > 0
            ? ManageInventoryState.metalType.toString()
            : "",
        metalColor:
          ManageInventoryState.metalColor.length > 0
            ? ManageInventoryState.metalColor.toString()
            : "",
        category:
          ManageInventoryState.category.length > 0
            ? ManageInventoryState.category.toString()
            : "",
        style: "",
        priceMin: priceValue[0] ? priceValue[0].toString() : "0",
        priceMax: priceValue[1] ? priceValue[1].toString() : "",
        sortColumnName: sortColumnName || "GFInventoryID",
        sortOrder: sortOrder || "ASC",
        pageNo: pageNo ? pageNo : 1,
        pageSize: pageSize ? pageSize : 15,
        gemstoneType:
          ManageInventoryState.gemstoneType.length > 0
            ? ManageInventoryState.gemstoneType.toString()
            : "",
        viewBy: "1",
        pricingLink: "true",
        skUs: searchValue ? searchValue.toString() : "",
        bindActive:
          bindActivePage == "Popular"
            ? "4"
            : bindActivePage == "Recently Updated"
            ? "7"
            : bindActivePage == "Archived Vendor"
            ? "5"
            : bindActivePage == "New"
            ? "3"
            : bindActivePage == "Pending Requests"
            ? "2"
            : bindActivePage == "Out Of Network"
            ? "6"
            : bindActivePage == "Network"
            ? "00"
            : bindActivePage == ""
            ? "1"
            : "0",
      };
      setContentLoading(true);
      setLoading(true);
      CommunityInventoryService.GetOneVendorProduct(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              console.log("loadOnce: " + loadOnce);
              setContentLoading(false);
              
              if (responseData.hasOwnProperty("dtParentChild")) {
                if (ManageInventoryState.productType.length === 0) {
                  setProductTypeList(responseData.dtParentChild);
                }
              }
              if (responseData.hasOwnProperty("dtProductType")) {
                if (ManageInventoryState.category.length === 0) {
                  setCategoriesList(responseData.dtProductType);
                }
              }
              if (responseData.hasOwnProperty("dtMetalType")) {
                if (ManageInventoryState.metalType.length === 0) {
                  setMetalTypeList(responseData.dtMetalType);
                }
              }
              if (responseData.hasOwnProperty("dtMetalColor")) {
                if (ManageInventoryState.metalColor.length === 0) {
                  setMetalColorList(responseData.dtMetalColor);
                }
              }
              if (responseData.hasOwnProperty("dtCollectionNames")) {
                if (ManageInventoryState.collection.length === 0) {
                  setCollectionList(responseData.dtCollectionNames);
                }
              }
              if (responseData.hasOwnProperty("dtGemstoneType")) {
                if (ManageInventoryState.gemstoneType.length === 0) {
                  setGemstoneList(responseData.dtGemstoneType);
                }
              }

              setVendorProductList(responseData.dtProducts);
              setProductTotalRecords(responseData.CountdtProducts[0].Count);
              setIsRestricted(responseData.ISRESTRICTED[0].ISRESTRICTED);

              // Safe handling of checkHidePrice
              if (
                responseData.PriceVisiblity &&
                responseData.PriceVisiblity[0] &&
                responseData.PriceVisiblity[0].checkHidePrice !== undefined
              ) {
                setCheckHidePrice(
                  responseData.PriceVisiblity[0].checkHidePrice
                );
                // Debug logging for price visibility
                console.log(
                  "checkHidePrice set to:",
                  responseData.PriceVisiblity[0].checkHidePrice,
                  "Type:",
                  typeof responseData.PriceVisiblity[0].checkHidePrice
                );
              } else {
                console.warn(
                  "PriceVisiblity not found or malformed, setting default value"
                );
                setCheckHidePrice("0"); // Default to show prices
              }
              //setIsRestricted(0);
              //

              if (responseData.dtProducts.length > 0) {
                if (responseData.dtProducts[0].IsactiveValue == true) {
                  setChecked(true);
                } else {
                  setChecked(false);
                }
              }
              let tempManageInv = ManageInventoryState;

              if (IsFirstCall) {
                setPriceValue([0, responseData?.MaxPrice?.[0].MaxPrice]);
                tempManageInv["priceMax"] = parseInt(
                  responseData?.MaxPrice?.[0]?.MaxPrice
                );
              }

              setManageInventoryState((prevState) => ({
                ...prevState,
                ...tempManageInv,
              }));
              setIsFirstCall(false);
            }
          } else {
            setContentLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setContentLoading(false);
        })
        .finally(() => {
          setContentLoading(false);
          setLoading(false);
          setTimeout(() => {
            if (viewItem === "list") {
              var antTableContent = document.querySelector(".ant-table-content"); if (antTableContent) antTableContent.scrollTop = 0;
              var antTableBody = document.querySelector(".ant-table-body"); if (antTableBody) antTableBody.scrollTop = 0;
            } else {
              var workingArea = document.getElementsByClassName("working__area")[0]; if (workingArea) workingArea.scrollTop = 0;
            }
          }, 100);
        });
    } catch (error) {
      console.log(error);
      setContentLoading(false);
    }
  };

  const handleGetOneVendorProductOnSelect = (id, name, vendorId) => {
    try {
      let inputData = {
        //bindWhat: bindWhatVal ? bindWhatVal : "ALL",
        bindWhat: "ALL",
        dealerID: id ? id.toString() : "",
        vendorId: vendorId ? vendorId.toString() : "",
        collection:
          ManageInventoryState.collection.length > 0
            ? ManageInventoryState.collection.toString()
            : "",
        productType:
          ManageInventoryState.productType.length > 0
            ? ManageInventoryState.productType.toString()
            : "",
        metalType:
          ManageInventoryState.metalType.length > 0
            ? ManageInventoryState.metalType.toString()
            : "",
        metalColor:
          ManageInventoryState.metalColor.length > 0
            ? ManageInventoryState.metalColor.toString()
            : "",
        category:
          ManageInventoryState.category.length > 0
            ? ManageInventoryState.category.toString()
            : "",
        style: "",
        priceMin: priceValue[0] ? priceValue[0].toString() : "0",
        priceMax: priceValue[1] ? priceValue[1].toString() : "",
        sortColumnName: "GFInventoryID",
        sortOrder: "ASC",
        pageNo: 1,
        pageSize: 15,
        gemstoneType:
          ManageInventoryState.gemstoneType.length > 0
            ? ManageInventoryState.gemstoneType.toString()
            : "",
        viewBy: "1",
        pricingLink: "true",
        skUs: searchValue ? searchValue.toString() : "",
        bindActive:
          bindActivePage == "Popular"
            ? "4"
            : bindActivePage == "Recently Updated"
            ? "7"
            : bindActivePage == "Archived Vendor"
            ? "5"
            : bindActivePage == "New"
            ? "3"
            : bindActivePage == "Pending Requests"
            ? "2"
            : bindActivePage == "Out Of Network"
            ? "6"
            : bindActivePage == "Network"
            ? "00"
            : bindActivePage == ""
            ? "1"
            : "0",
      };
      setContentLoading(true);
      CommunityInventoryService.GetOneVendorProduct(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              //console.log('loadOnce: ' + loadOnce);
              setContentLoading(false);
              console.log("name: " + name);
              if (name == "productType") {
                if (ManageInventoryState.productType.length === 0) {
                  setProductTypeList(responseData.dtParentChild);
                }
                setCategoriesList(responseData.dtProductType);
                setMetalColorList(responseData.dtMetalColor);
                setCollectionList(responseData.dtCollectionNames);
                setGemstoneList(responseData.dtGemstoneType);
                setMetalTypeList(responseData.dtMetalType);
              } else if (name == "metalColor") {
                setProductTypeList(responseData.dtParentChild);
                setCategoriesList(responseData.dtProductType);
                setMetalTypeList(responseData.dtMetalType);
                if (ManageInventoryState.metalColor.length === 0) {
                  setMetalColorList(responseData.dtMetalColor);
                }
                setCollectionList(responseData.dtCollectionNames);
                setGemstoneList(responseData.dtGemstoneType);
              } else if (name == "category") {
                setProductTypeList(responseData.dtParentChild);
                if (ManageInventoryState.category.length === 0) {
                  setCategoriesList(responseData.dtProductType);
                }
                setMetalTypeList(responseData.dtMetalType);
                setMetalColorList(responseData.dtMetalColor);
                setCollectionList(responseData.dtCollectionNames);
                setGemstoneList(responseData.dtGemstoneType);
              } else if (name == "metalType") {
                setProductTypeList(responseData.dtParentChild);
                setCategoriesList(responseData.dtProductType);
                if (ManageInventoryState.metalType.length === 0) {
                  setMetalTypeList(responseData.dtMetalType);
                }
                setMetalColorList(responseData.dtMetalColor);
                setCollectionList(responseData.dtCollectionNames);
                setGemstoneList(responseData.dtGemstoneType);
              } else if (name == "gemstoneType") {
                setProductTypeList(responseData.dtParentChild);
                setCategoriesList(responseData.dtProductType);
                setMetalTypeList(responseData.dtMetalType);
                setMetalColorList(responseData.dtMetalColor);
                setCollectionList(responseData.dtCollectionNames);
                if (ManageInventoryState.gemstoneType.length === 0) {
                  setGemstoneList(responseData.dtGemstoneType);
                }
              } else if (name == "collection") {
                setProductTypeList(responseData.dtParentChild);
                setCategoriesList(responseData.dtProductType);
                setMetalTypeList(responseData.dtMetalType);
                setMetalColorList(responseData.dtMetalColor);
                setGemstoneList(responseData.dtGemstoneType);
                if (ManageInventoryState.collection.length === 0) {
                  setCollectionList(responseData.dtCollectionNames);
                }
              } else if (name == "") {
                setProductTypeList(responseData.dtParentChild);
                setCategoriesList(responseData.dtProductType);
                setMetalTypeList(responseData.dtMetalType);
                setMetalColorList(responseData.dtMetalColor);
                setCollectionList(responseData.dtCollectionNames);
                setGemstoneList(responseData.dtGemstoneType);
              }
            }
          } else {
            setContentLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setContentLoading(false);
        });
    } catch (error) {
      console.log(error);
      setContentLoading(false);
    }
  };

  const handleTableASCDES = (pagination, filters, sorter) => {
    var contentArea = document.getElementsByClassName("content__area")[0]; if (contentArea) contentArea.scrollTop = 0;
    var antTableBody = document.querySelector(".ant-table-body"); if (antTableBody) antTableBody.scrollTop = 0; var antTableContent = document.querySelector(".ant-table-content"); if (antTableContent) antTableContent.scrollTop = 0;
    let type = "";
    let column = "";
    //sorting
    if (sorter.order == "descend") {
      type = "DESC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else if (sorter.order == "ascend") {
      type = "ASC";
      column = sorter.field;

      setSortType(type);
      setSortColumnName(column);
    } else {
      type = "ASC";
      column = "GFInventoryID";
      setSortColumnName(column);
      setSortType(type);
    }
    handleGetOneVendorProduct(
      dealerId,
      vendorId,
      bindWhatVal,
      searchValue,
      priceValue,
      pageNo,
      pageSize,
      column,
      type
    );
  };

  const handleApplyFilter = () => {
    setPageNo(1);
    handleGetOneVendorProduct(
      dealerId,
      vendorId,
      bindWhatVal,
      searchValue,
      priceValue,
      1,
      pageSize,
      sortColumnName,
      sortType
    );
  };

  const onResetFilter = () => {
    let tempState = ManageInventoryState;
    tempState["productType"] = [];
    tempState["category"] = [];
    tempState["metalColor"] = [];
    tempState["metalType"] = [];
    tempState["collection"] = [];
    tempState["gemstoneType"] = [];
    setManageInventoryState((prevState) => ({
      ...prevState,
      ...tempState,
    }));
    setPriceValue([
      ManageInventoryState.priceMin,
      ManageInventoryState.priceMax,
    ]);
    SetSearchValue("");
    handleGetOneVendorProductOnSelect(dealerId, "", vendorId);
    handleGetOneVendorProduct(
      dealerId,
      vendorId,
      bindWhatVal,
      "",
      [0, 0],
      1,
      15
    );
    setPageNo(1);
    setPageSize(15);
  };

  const onChangeMultiDrop = (e, name) => {
    setHideShowFilter(true);
    let tempState = ManageInventoryState;
    if (e.includes("")) {
      tempState[name] = [];
      tempState[name].push("");
    } else {
      tempState[name] = e;
    }
    setManageInventoryState((prevState) => ({
      ...prevState,
      ...tempState,
    }));

    handleGetOneVendorProductOnSelect(dealerId, name, vendorId);
    //handleApplyFilter();
  };

  const handleOpenDetailsModal = (row) => {
    handleProductChangeOpen(row.GFInventoryID, true);
  };

  const handleProductChangeOpen = (prodId, val) => {
    try {

    const effectiveDealerId =
      dealerId ||
      loginDealerId ||
      (loginDetials &&
        loginDetials.loginDetials &&
        loginDetials.loginDetials.responseData &&
        loginDetials.loginDetials.responseData.dealerId) ||
      "";

    let inputData = {
      dealerID: effectiveDealerId.toString(),
      productID: prodId ? prodId.toString() : "",
    };

      // let inputData = {
      //   dealerID: loginDealerId.toString(),
      //   productID: prodId ? prodId.toString() : "",
      // };
      // debugger
      CommunityInventoryService.GetOneProductDetail(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setContentLoading(false);
              setVendorProductDetail(responseData.dtProductDetail);
            }
          } else {
            setContentLoading(false);
            setVendorProductDetail(responseData.dtProducts);
          }
          if (val == false) {
          } else setVisible(true);
        })
        .catch((error) => {
          setContentLoading(false);
          console.log(error);
        });
    } catch (error) {
      setContentLoading(false);
      console.log(error);
    }
    setSelectedgfInventoryID(prodId);
    setProductChange(!productChange);
  };

  const handleProductChangeClose = () => {
    setSelectedgfInventoryID(0);
    setProductChange(false);
    setVendorProductDetail([]);
  };

  // Build columns based on a flag

  function handlePageNoChange(page, pageSize) {
    var contentArea = document.getElementsByClassName("content__area")[0];
    if (contentArea) contentArea.scrollTop = 0;
    var antTableBody = document.querySelector(".ant-table-body");
    if (antTableBody) antTableBody.scrollTop = 0;
    if (page !== pageNo) {
      setPageNo(page);
      handleGetOneVendorProduct(
        dealerId,
        vendorId,
        bindWhatVal,
        searchValue,
        priceValue,
        page,
        pageSize,
        sortColumnName,
        sortType
      );
    }
  }

  function handlePageSizeChange(current, size) {
    var contentArea = document.getElementsByClassName("content__area")[0];
    if (contentArea) contentArea.scrollTop = 0;
    var antTableBody = document.querySelector(".ant-table-body"); if (antTableBody) antTableBody.scrollTop = 0; var antTableContent = document.querySelector(".ant-table-content"); if (antTableContent) antTableContent.scrollTop = 0;
    setPageSize(size);
    handleGetOneVendorProduct(
      dealerId,
      vendorId,
      bindWhatVal,
      searchValue,
      priceValue,
      pageNo,
      size,
      sortColumnName,
      sortType
    );
  }

  const handleToggleOnChange = (checked, gfInventoryID) => {
    setActiveDeactiveAll("");

    setVendorProductList((prevList) => {
      const temp = prevList.map((x) =>
        x.GFInventoryID === gfInventoryID ? { ...x, IsActive: checked } : x
      );

      return temp;
    });

    if (checked) {
      setActiveProductIds((oldArray) => [...oldArray, gfInventoryID]);
      setInActiveProductIds((oldArray) =>
        oldArray.filter((prevState) => prevState !== gfInventoryID)
      );
    } else {
      setInActiveProductIds((oldArray) => [...oldArray, gfInventoryID]);
      setActiveProductIds((oldArray) =>
        oldArray.filter((prevState) => prevState !== gfInventoryID)
      );
    }
  };

  const handleSaveUpdateFlag = () => {
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        activeproductIds: activeProductIds.toString(),
        deactiveproductIds: inActiveProductIds.toString(),
        flagValue: "AC",
        vendorId: vendorId ? vendorId.toString() : "",
        productType: "",
      };
      CommunityInventoryService.SaveUpdateFlag(inputData)
        .then((response) => {
          let message = response.data.message;
          if (message === "Success") {
            NotificationManager.success(t("Data Updated Successfully."));
            handleGetOneVendorProduct(
              dealerId,
              vendorId,
              bindWhatVal,
              searchValue,
              priceValue,
              pageNo,
              pageSize,
              sortColumnName,
              sortType
            );
          } else {
            NotificationManager.error(t("Data Not Updated."));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleActiveDeactiveOnChange = (e) => {
    const temp = vendorProductList.map((x) => {
      if (x.IsActive == checked) {
        return { ...x, IsActive: !checked };
      } else return x;
    });
    setVendorProductList(temp);
    setChecked(!checked);
    setActiveDeactiveAll("All");
  };

  const handleSaveUpdate = () => {
    if (activeDeactiveAll == "All") {
      setVisibleAll(true);
    } else handleSaveUpdateFlag();
  };

  const handleSaveUpdateAll = () => {
    try {
      let filterData = {
        bindWhat: "ALL",
        dealerID: dealerId ? dealerId.toString() : "",
        vendorId: vendorId ? vendorId.toString() : "",
        collection:
          ManageInventoryState.collection.length > 0
            ? ManageInventoryState.collection.toString()
            : "",
        productType:
          ManageInventoryState.productType.length > 0
            ? ManageInventoryState.productType.toString()
            : "",
        metalType:
          ManageInventoryState.metalType.length > 0
            ? ManageInventoryState.metalType.toString()
            : "",
        metalColor:
          ManageInventoryState.metalColor.length > 0
            ? ManageInventoryState.metalColor.toString()
            : "",
        category:
          ManageInventoryState.category.length > 0
            ? ManageInventoryState.category.toString()
            : "",
        style: "",
        priceMin: priceValue[0] ? priceValue[0].toString() : "0",
        priceMax: priceValue[1] ? priceValue[1].toString() : "",
        sortColumnName: sortColumnName || "GFInventoryID",
        sortOrder: sortType || "ASC",
        pageNo: pageNo ? pageNo : 1,
        pageSize: pageSize ? pageSize : 15,
        gemstoneType:
          ManageInventoryState.gemstoneType.length > 0
            ? ManageInventoryState.gemstoneType.toString()
            : "",
        viewBy: "1",
        pricingLink: "true",
        skUs: searchValue ? searchValue.toString() : "",
        bindActive:
          bindActivePage == "Popular"
            ? "4"
            : bindActivePage == "Recently Updated"
            ? "7"
            : bindActivePage == "Archived Vendor"
            ? "5"
            : bindActivePage == "New"
            ? "3"
            : bindActivePage == "Pending Requests"
            ? "2"
            : bindActivePage == "Out Of Network"
            ? "6"
            : bindActivePage == "Network"
            ? "00"
            : bindActivePage == ""
            ? "1"
            : "0",
      };
      let inputData = {
        dealerID: dealerId.toString(),
        value: checked ? "1" : "0",
        vendorId: vendorId ? vendorId.toString() : "",
        productType: "",
        filterData: filterData,
      };
      setUpdateFlagLoading(true);
      CommunityInventoryService.SaveUpdateFlagAll(inputData)
        .then((response) => {
          let message = response.data.message;
          if (message === "Success") {
            setVisibleAll(false);
            setUpdateFlagLoading(false);
            NotificationManager.success(t("Data Updated Successfully."));
            handleGetOneVendorProduct(
              dealerId,
              vendorId,
              bindWhatVal,
              searchValue,
              priceValue,
              pageNo,
              pageSize,
              sortColumnName,
              sortType
            );
            setActiveDeactiveAll("");
            setChecked(false);
          } else {
            setVisibleAll(false);
            setUpdateFlagLoading(false);
            NotificationManager.error(t("Data Not Updated."));
            setActiveDeactiveAll("");
            setChecked(false);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*Custom API Binding Ends*/
  return (
    <React.Fragment>
      <div className="prodetail__section">
        <div className="form__fields inventory__form__fields">
          <div className="col-md-12">
            <div className="prod__maindiv prodmarkup__secion retailerprof__section permission__section">
              <div className="row">
                <div className="col-lg-9 col-md-9">
                  <div className="prodesc__div">
                    <div className="allprod_section inventory">
                      <div className="row">
                        <div className="col-md-12">
                          {/* here */}

                          {IsRestricted === "0" ? (
                            <div
                              style={{
                                fontSize: "24px",
                                color: "red",
                                fontWeight: "bold",
                                padding: "20px",
                                textAlign: "center",
                                border: "2px solid red",
                                borderRadius: "8px",
                                backgroundColor: "#ffe6e6",
                              }}
                            >
                              You don’t have access
                            </div>
                          ) : (
                            // Your existing content when IsRestricted is NOT 0
                            <div className="filter_section mt-0 p-0">
                              <div className="col-md-12 desktop__view">
                                <div className="filt_optndiv">
                                  <div className="gview__div justify-baseline">
                                    <span className="mr-2">
                                      <b>
                                        {" "}
                                        {t("Total")}{" "}
                                        {productTotalRecords
                                          ? productTotalRecords
                                          : "0"}{" "}
                                        {t("Product")}{" "}
                                      </b>
                                    </span>
                                    <span
                                      className={
                                        viewItem === "grid"
                                          ? "fa fa-th grid_icon active"
                                          : "fa fa-th grid_icon"
                                      }
                                      onClick={() => {
                                        handleViewChange("grid");
                                      }}
                                    ></span>
                                    <span
                                      className={
                                        viewItem === "list"
                                          ? "fa fa-th-list list_icon active"
                                          : "fa fa-th-list list_icon"
                                      }
                                      onClick={() => {
                                        handleViewChange("list");
                                      }}
                                    ></span>
                                  </div>
                                  <div className="search__btn mb-0">
                                    <Search
                                      placeholder={t("Keyword Or SKU")}
                                      allowClear
                                      onChange={(e) =>
                                        SetSearchValue(e.target.value)
                                      }
                                      onSearch={onSearchFunc}
                                      value={searchValue}
                                    />
                                  </div>
                                  <div className="drpdwn__div d-none"></div>
                                </div>
                              </div>

                              <div className="col-md-12 mobile__view">
                                <div className="filt_optndiv">
                                  <div className="gview__div mobile__bottomspace">
                                    <p className="mb-0">
                                      <span
                                        className={
                                          viewItem === "grid"
                                            ? "fa fa-th grid_icon active"
                                            : "fa fa-th grid_icon"
                                        }
                                        onClick={() => {
                                          handleViewChange("grid");
                                        }}
                                      ></span>
                                      <span
                                        className={
                                          viewItem === "list"
                                            ? "fa fa-th-list list_icon active"
                                            : "fa fa-th-list list_icon"
                                        }
                                        onClick={() => {
                                          handleViewChange("list");
                                        }}
                                      ></span>
                                    </p>

                                    <span>
                                      <b>
                                        {" "}
                                        {t("Total")}{" "}
                                        {productTotalRecords
                                          ? productTotalRecords
                                          : "0"}{" "}
                                        {t("Product")}{" "}
                                      </b>
                                    </span>
                                  </div>

                                  <div className="search__bar mb-0 w-100">
                                    <Search
                                      placeholder={t("Keyword Or SKU")}
                                      allowClear
                                      onChange={(e) =>
                                        SetSearchValue(e.target.value)
                                      }
                                      onSearch={onSearchFunc}
                                      value={searchValue}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-12 mt-3">
                                <div className="row align-items-center">
                                  <div className="col-md-4">
                                    <div className="deactivation__link">
                                      <a
                                        href="https://platform.stage.jewelcloud.com//Catalog/GuideLines/GemFind%20Product%20Deactivation%20Guide.pdf"
                                        download
                                        target="_blank"
                                      >
                                        {t("Product Deactivation Guidelines")}{" "}
                                      </a>
                                    </div>
                                  </div>
                                  <div className="col-md-8">
                                    <div className="filt_optndiv justify-content-end">
                                      {dashBoardVendorLeftPanelInfoList?.memberShipType ===
                                        "Retailer" &&
                                        rowDetails?.Status === "Connected" && (
                                          <div className="filtbtn__div">
                                            <span className="select__all mobile__bottomspace">
                                              <input
                                                type="checkbox"
                                                id="sel"
                                                value={checked}
                                                checked={checked}
                                                onChange={(e) =>
                                                  handleActiveDeactiveOnChange(
                                                    e
                                                  )
                                                }
                                              />
                                              <label htmlFor="sel">
                                                {t("Activate/Deactivate All")}{" "}
                                                {productTotalRecords
                                                  ? productTotalRecords
                                                  : "0"}{" "}
                                                {t("Products")}
                                              </label>
                                            </span>
                                          </div>
                                        )}

                                      <button
                                        className="primary-btn ml-2"
                                        onClick={handleHideShowFilter}
                                      >
                                        <img src={Filter_icon} alt="" />
                                        {hideShowFilter ? (
                                          <span>
                                            {t("Hide Filter")}{" "}
                                            <i className="fa fa-angle-up"></i>
                                          </span>
                                        ) : (
                                          <span>
                                            {t("Show Filter")}{" "}
                                            <i className="fa fa-angle-down"></i>
                                          </span>
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-12 relative">
                                <div
                                  className={
                                    hideShowFilter
                                      ? "form__fields filter_inpsection"
                                      : "form__fields filter_inpsection hide"
                                  }
                                >
                                  <Spin spinning={contentLoading} size="large">
                                    <div className="col-md-12">
                                      <div className="row">
                                        <div className="col-lg-4 col-md-6">
                                          <div className="input__block">
                                            <label> {t("Product Type")} </label>
                                            <Select
                                              showSearch
                                              mode="multiple"
                                              showArrow
                                              className="border__grey"
                                              placeholder={t(
                                                "Select Product Type"
                                              )}
                                              optionFilterProp="children"
                                              value={
                                                ManageInventoryState.productType
                                              }
                                              onChange={(e) =>
                                                onChangeMultiDrop(
                                                  e,
                                                  "productType"
                                                )
                                              }
                                              onSearch={onSearch}
                                              allowClear
                                            >
                                              {ProductTypeList.length > 0 &&
                                                ProductTypeList.map(
                                                  (item, i) => {
                                                    return (
                                                      <Option
                                                        value={item.ProductType}
                                                      >
                                                        {item.Text} (
                                                        {item.ProductCount})
                                                      </Option>
                                                    );
                                                  }
                                                )}
                                            </Select>
                                          </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6">
                                          <div className="input__block">
                                            <label> {t("Categories")} </label>
                                            <Select
                                              showSearch
                                              showArrow
                                              mode="multiple"
                                              className="border__grey"
                                              placeholder={t(
                                                "Select Categories"
                                              )}
                                              optionFilterProp="children"
                                              value={
                                                ManageInventoryState.category
                                              }
                                              onChange={(e) =>
                                                onChangeMultiDrop(e, "category")
                                              }
                                              onSearch={onSearch}
                                              allowClear
                                            >
                                              {CategoriesList.length > 0 &&
                                                CategoriesList.map(
                                                  (item, i) => {
                                                    return (
                                                      <Option
                                                        value={
                                                          item.JewelryCategoryID
                                                        }
                                                      >
                                                        {item.JewelryCategory} (
                                                        {item.ProductCount})
                                                      </Option>
                                                    );
                                                  }
                                                )}
                                            </Select>
                                          </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6">
                                          <div className="input__block">
                                            <label> {t("Collection")} </label>
                                            <Select
                                              showSearch
                                              showArrow
                                              mode="multiple"
                                              className="border__grey"
                                              placeholder={t(
                                                "Select Collection"
                                              )}
                                              optionFilterProp="children"
                                              value={
                                                ManageInventoryState.collection
                                              }
                                              onChange={(e) =>
                                                onChangeMultiDrop(
                                                  e,
                                                  "collection"
                                                )
                                              }
                                              onSearch={onSearch}
                                              allowClear
                                            >
                                              {CollectionList.length > 0 &&
                                                CollectionList.map(
                                                  (item, i) => {
                                                    return (
                                                      <Option
                                                        value={
                                                          item.CollectionNameId
                                                        }
                                                      >
                                                        {item.CollectionNames}{" "}
                                                        ({item.ProductCount})
                                                      </Option>
                                                    );
                                                  }
                                                )}
                                            </Select>
                                          </div>
                                        </div>

                                        <div className="col-lg-4 col-md-6">
                                          <div className="input__block">
                                            <label> {t("Metal Type")} </label>
                                            <Select
                                              showSearch
                                              showArrow
                                              mode="multiple"
                                              className="border__grey"
                                              placeholder={t(
                                                "Select Metal Type"
                                              )}
                                              optionFilterProp="children"
                                              value={
                                                ManageInventoryState.metalType
                                              }
                                              onChange={(e) =>
                                                onChangeMultiDrop(
                                                  e,
                                                  "metalType"
                                                )
                                              }
                                              onSearch={onSearch}
                                              allowClear
                                            >
                                              {MetalTypeList.map((item, i) => {
                                                return (
                                                  <Option
                                                    value={item.MetalTypeID}
                                                  >
                                                    {item.MetalType} (
                                                    {item.ProductCount})
                                                  </Option>
                                                );
                                              })}
                                            </Select>
                                          </div>
                                        </div>

                                        <div className="col-lg-4 col-md-6">
                                          <div className="input__block">
                                            <label> {t("Metal Color")} </label>
                                            <Select
                                              showSearch
                                              showArrow
                                              mode="multiple"
                                              className="border__grey"
                                              placeholder={t(
                                                "Select Metal Color"
                                              )}
                                              optionFilterProp="children"
                                              value={
                                                ManageInventoryState.metalColor
                                              }
                                              onChange={(e) =>
                                                onChangeMultiDrop(
                                                  e,
                                                  "metalColor"
                                                )
                                              }
                                              onSearch={onSearch}
                                              allowClear
                                            >
                                              {MetalColorList.map((item, i) => {
                                                return (
                                                  <Option
                                                    value={item.MetalColorID}
                                                  >
                                                    {item.MetalColor} (
                                                    {item.ProductCount})
                                                  </Option>
                                                );
                                              })}
                                            </Select>
                                          </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6">
                                          <div className="input__block">
                                            <label> {t("Gemstone")} </label>
                                            <Select
                                              showSearch
                                              showArrow
                                              mode="multiple"
                                              className="border__grey"
                                              placeholder={t("Select Gemstone")}
                                              optionFilterProp="children"
                                              value={
                                                ManageInventoryState.gemstoneType
                                              }
                                              onChange={(e) =>
                                                onChangeMultiDrop(
                                                  e,
                                                  "gemstoneType"
                                                )
                                              }
                                              onSearch={onSearch}
                                              allowClear
                                            >
                                              {GemstoneList.map((item, i) => {
                                                return (
                                                  <Option
                                                    value={item.GemstoneTypeID}
                                                  >
                                                    {item.GemstoneType} (
                                                    {item.ProductCount})
                                                  </Option>
                                                );
                                              })}
                                            </Select>
                                          </div>
                                        </div>

                                        <div className="col-lg-4 col-md-6">
                                          <div className="input__block">
                                            <label> {t("MSRP")} </label>
                                            <div className="col-md-12 mt-3">
                                              <Slider
                                                range
                                                value={priceValue}
                                                min={
                                                  ManageInventoryState.priceMin
                                                    ? ManageInventoryState.priceMin
                                                    : 0
                                                }
                                                max={
                                                  ManageInventoryState.priceMax
                                                    ? ManageInventoryState.priceMax
                                                    : 0
                                                }
                                                onChange={(e) => {
                                                  setPriceValue(e);
                                                }}
                                              />
                                              <div className="rangeSlider__values">
                                                <div className="input__block">
                                                  <input
                                                    type="text"
                                                    disabled="true"
                                                    value={
                                                      currencySymbol +
                                                      priceValue?.[0]?.toLocaleString(
                                                        "en-US"
                                                      )
                                                    }
                                                  />
                                                </div>
                                                <div>
                                                  <img
                                                    src={space__icon}
                                                    className="img-fluid space__icon"
                                                  />
                                                </div>
                                                <div className="input__block">
                                                  <input
                                                    type="text"
                                                    disabled="true"
                                                    value={
                                                      currencySymbol +
                                                      priceValue?.[1]?.toLocaleString(
                                                        "en-US"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-md-12 filtbtn_div">
                                          <Button
                                            className="primary-btn mr-2"
                                            onClick={() => onResetFilter()}
                                          >
                                            {" "}
                                            {t("Reset Filters")}
                                          </Button>
                                          <Button
                                            className="primary-btn"
                                            onClick={() => {
                                              handleApplyFilter();
                                            }}
                                            loading={contentLoading}
                                          >
                                            {t("Apply Filters")}
                                          </Button>
                                        </div>
                                      </div>
                                    </div>
                                  </Spin>
                                </div>
                              </div>

                              {viewItem === "grid" && (
                                <React.Fragment>
                                  <Spin spinning={contentLoading} size="large">
                                    <div className="col-md-12">
                                      <div className="prod__section">
                                        <div className="row">
                                          {vendorProductList.length > 0 &&
                                            vendorProductList.map((item) => {
                                              return (
                                                <div className="col-lg-4 col-md-6 mb-4">
                                                  <div className="prod__maindiv">
                                                    <div className="chkbx__div">
                                                      <input
                                                        type="checkbox"
                                                        value={item.IsActive}
                                                        checked={item.IsActive}
                                                        onChange={(e) => {
                                                          handleToggleOnChange(
                                                            e.target.checked,
                                                            item.GFInventoryID
                                                          );
                                                        }}
                                                        disabled={
                                                          !(
                                                            dashBoardVendorLeftPanelInfoList?.memberShipType ===
                                                              "Retailer" &&
                                                            rowDetails?.Status ===
                                                              "Connected"
                                                          )
                                                        }
                                                        style={{
                                                          visibility:
                                                            dashBoardVendorLeftPanelInfoList?.memberShipType ===
                                                              "Retailer" &&
                                                            rowDetails?.Status ===
                                                              "Connected"
                                                              ? "visible"
                                                              : "hidden",
                                                        }}
                                                      />
                                                    </div>

                                                    <div className="prodimg__div">
                                                      <img
                                                        src={
                                                          item.imagepath
                                                            ? item.imagepath
                                                            : ""
                                                        }
                                                        alt=""
                                                      />
                                                    </div>
                                                    <div className="details__div">
                                                      <span className="style__txt">
                                                        SKU No: {item.SKU}
                                                      </span>
                                                      <span className="price__txt">
                                                        {(() => {
                                                          const shouldHidePrice =
                                                            checkHidePrice ===
                                                              "true" ||
                                                            checkHidePrice ===
                                                              "1" ||
                                                            checkHidePrice ===
                                                              1;
                                                          if (shouldHidePrice) {
                                                            return " - ";
                                                          }
                                                          return item.MSRP && item.MSRP !== "0" && item.MSRP !== "N/A"
                                                            ? item.CurrenySymbol +
                                                                " " +
                                                                item.MSRP
                                                            : " - ";
                                                        })()}
                                                      </span>
                                                    </div>
                                                    {item.GFInventoryID !=
                                                    selectedgfInventoryID ? (
                                                      <div
                                                        className="info__div"
                                                        onClick={() => {
                                                          handleProductChangeOpen(
                                                            item.GFInventoryID,
                                                            false
                                                          );
                                                        }}
                                                      >
                                                        <img
                                                          src={Info_icon}
                                                          alt=""
                                                        />
                                                      </div>
                                                    ) : item.GFInventoryID ==
                                                      selectedgfInventoryID ? (
                                                      vendorProductDetail.map(
                                                        (item) => {
                                                          return (
                                                            <div className="descr__div">
                                                              <div className="overlay__block">
                                                                <p className="manageInv-info-sp">
                                                                  <span>
                                                                    {" "}
                                                                    {t(
                                                                      "Style"
                                                                    )}{" "}
                                                                  </span>
                                                                  <span>:</span>
                                                                  <span>
                                                                    {
                                                                      item.StyleNo
                                                                    }
                                                                  </span>
                                                                </p>
                                                                <p className="manageInv-info-sp">
                                                                  <span>
                                                                    {" "}
                                                                    {t(
                                                                      "Collection"
                                                                    )}{" "}
                                                                  </span>
                                                                  <span>:</span>
                                                                  <span>
                                                                    {item.Coll}
                                                                  </span>
                                                                </p>
                                                                <p className="manageInv-info-sp">
                                                                  <span>
                                                                    {" "}
                                                                    {t(
                                                                      "Metal Type"
                                                                    )}{" "}
                                                                  </span>
                                                                  <span>:</span>
                                                                  <span>
                                                                    {
                                                                      item.MetalType
                                                                    }
                                                                  </span>
                                                                </p>
                                                                <p className="manageInv-info-sp">
                                                                  <span>
                                                                    {" "}
                                                                    {t(
                                                                      "Metal Color"
                                                                    )}{" "}
                                                                  </span>
                                                                  <span>:</span>
                                                                  <span>
                                                                    {
                                                                      item.MetalColor
                                                                    }
                                                                  </span>
                                                                </p>
                                                                <p className="manageInv-info-sp">
                                                                  <span>
                                                                    {" "}
                                                                    {t(
                                                                      "MSRP Price"
                                                                    )}{" "}
                                                                  </span>
                                                                  <span>:</span>
                                                                  <span>
                                                                    {(() => {
                                                                      const shouldHidePrice =
                                                                        checkHidePrice ===
                                                                          "true" ||
                                                                        checkHidePrice ===
                                                                          "1" ||
                                                                        checkHidePrice ===
                                                                          1;
                                                                      if (
                                                                        shouldHidePrice
                                                                      ) {
                                                                        return " - ";
                                                                      }
                                                                      return item.MSRP ==
                                                                        "0" ||
                                                                        item.MSRP ==
                                                                          "N/A"
                                                                        ? " - "
                                                                        : item.MSRP
                                                                        ? item.CurrenySymbol +
                                                                          " " +
                                                                          item.MSRP
                                                                        : " - ";
                                                                    })()}
                                                                  </span>
                                                                </p>
                                                              </div>
                                                              <div
                                                                className="close__div"
                                                                onClick={
                                                                  handleProductChangeClose
                                                                }
                                                              >
                                                                <img
                                                                  src={Close}
                                                                  alt=""
                                                                />
                                                              </div>
                                                            </div>
                                                          );
                                                        }
                                                      )
                                                    ) : (
                                                      <div className="descr__div">
                                                        <div className="overlay__block">
                                                          <p className="manageInv-info-sp">
                                                            <span>
                                                              {" "}
                                                              {t("Style")}{" "}
                                                            </span>
                                                            <span>:</span>
                                                            <span>N/A</span>
                                                          </p>
                                                          <p className="manageInv-info-sp">
                                                            <span>
                                                              {" "}
                                                              {t(
                                                                "Collection"
                                                              )}{" "}
                                                            </span>
                                                            <span>:</span>
                                                            <span>N/A</span>
                                                          </p>
                                                          <p className="manageInv-info-sp">
                                                            <span>
                                                              {" "}
                                                              {t(
                                                                "Metal Type"
                                                              )}{" "}
                                                            </span>
                                                            <span>:</span>
                                                            <span>N/A</span>
                                                          </p>
                                                          <p className="manageInv-info-sp">
                                                            <span>
                                                              {" "}
                                                              {t(
                                                                "Metal Color"
                                                              )}{" "}
                                                            </span>
                                                            <span>:</span>
                                                            <span>N/A</span>
                                                          </p>
                                                          <p className="manageInv-info-sp">
                                                            <span>
                                                              {" "}
                                                              {t(
                                                                "MSRP Price"
                                                              )}{" "}
                                                            </span>
                                                            <span>:</span>
                                                            <span>
                                                              {(() => {
                                                                const shouldHidePrice =
                                                                  checkHidePrice ===
                                                                    "true" ||
                                                                  checkHidePrice ===
                                                                    "1" ||
                                                                  checkHidePrice ===
                                                                    1;
                                                                return shouldHidePrice
                                                                  ? " - "
                                                                  : "N/A";
                                                              })()}
                                                            </span>
                                                          </p>
                                                        </div>
                                                        <div
                                                          className="close__div"
                                                          onClick={
                                                            handleProductChangeClose
                                                          }
                                                        >
                                                          <img
                                                            src={Close}
                                                            alt=""
                                                          />
                                                        </div>
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              );
                                            })}
                                        </div>
                                      </div>
                                    </div>
                                  </Spin>
                                </React.Fragment>
                              )}
                              {viewItem === "list" && (
                                <div className="col-md-12 mt-3">
                                  <div className="lviewprod__tbl info__tooltip__table">
                                    <Table
                                      columns={columns}
                                      dataSource={vendorProductList}
                                      loading={contentLoading}
                                      pagination={false}
                                      onChange={handleTableASCDES}
                                    />
                                  </div>
                                </div>
                              )}
                              <div className="col-md-12">
                                <Pagination
                                  style={{
                                    marginTop: "10px",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                  total={productTotalRecords}
                                  current={pageNo}
                                  pageSize={pageSize}
                                  pageSizeOptions={[10, 20, 50, 100]}
                                  responsive={true}
                                  showSizeChanger={true}
                                  onChange={handlePageNoChange}
                                  onShowSizeChange={handlePageSizeChange}
                                />
                              </div>

                              {dashBoardVendorLeftPanelInfoList?.memberShipType ===
                                "Retailer" &&
                                rowDetails?.Status === "Connected" && (
                                  <div className="col-md-12">
                                    <div className="save__btn mt-3">
                                      <button
                                        className="primary-btn"
                                        onClick={handleSaveUpdate}
                                      >
                                        {t("Save Changes")}
                                      </button>
                                    </div>
                                  </div>
                                )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-3">
                  <Spin spinning={sideProfileLoading}>
                    <div className="right__section">
                      <div className="profile__block">
                        <span className="linkText">
                          {rowDetails.DesignerName
                            ? rowDetails.DesignerName
                            : null}
                        </span>
                        <div className="logoImg__block p-0">
                          <img src={rowDetails.DesignerLogo} />
                        </div>
                        <p className="activeFrom">
                          {t("Updated")} |{" "}
                          {rowDetails.Modified ? rowDetails.Modified.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3') : null}
                        </p>

                        <div className="star-ratings">
                          <p className="mb-0"> {t("Data Ratings")} </p>
                          <StarRatings
                            rating={
                              rowDetails.RatingCount
                                ? rowDetails.RatingCount
                                : 0
                            }
                            // rating={4}
                            starRatedColor="#1883b8"
                            starDimension="18px"
                            starSpacing="0px"
                            numberOfStars={5}
                          />
                        </div>

                        <div>
                          <p>
                            {" "}
                            {rowDetails.Status ? rowDetails.Status : null}{" "}
                          </p>
                        </div>
                        {rowDetails.Status == "Connected" ? null : (
                          vendorMembershipType != 'Vendor' ?
                          <div className="input__block">
                            <button
                              className={
                                IsRestricted === "0" ? "disabled-btn" : "primary-btn"
                              }
                              onClick={() => {
                                setIsModalSendInvitationVisible(true);
                                handleGeneratePopup(dealerId);
                              }}
                              disabled={IsRestricted === "0"}
                            >
                              {rowDetails.Action
                                ? rowDetails.Action
                                : "Request Update"}
                            </button>
                          </div>
                        :"")}
                      </div>

                      <div className="links__block">
                        <ul>
                          <li
                            onClick={() => {
                              const collectionCount = IsRestricted === "0" ? 0 : Number(rowDetails.Collections || 0);
                              if (collectionCount === 0) return;
                              rowDetails.Status == "Connected"
                                ? localStorage.setItem(
                                    "vendorDataForCollection",
                                    rowDetails.txtDesignerName
                                  )
                                : NotificationManager.error(
                                    t("Please connect this vendor")
                                  );
                            }}
                          >
                            {(IsRestricted === "0" || !rowDetails.Collections || Number(rowDetails.Collections) === 0) ? (
                              <span style={{ color: '#333', cursor: 'default' }}>
                                {"0"}{" "}
                                {t("Collections")}{" "}
                              </span>
                            ) : (
                              <Link
                                to={
                                  rowDetails.Status == "Connected" &&
                                  "/manageCollection"
                                }
                              >
                                {rowDetails.Collections}{" "}
                                {t("Collections")}{" "}
                              </Link>
                            )}
                          </li>
                          <li>
                            {(IsRestricted === "0" || !rowDetails.items1 || Number(rowDetails.items1) === 0) ? (
                              <span style={{ color: '#333', cursor: 'default' }}>
                                {"0"}{" "}
                                {t("Items")}{" "}
                              </span>
                            ) : (
                              <span className="linkText">
                                {rowDetails.items1}{" "}
                                {t("Items")}{" "}
                              </span>
                            )}
                          </li>
                        </ul>
                        <hr />
                      </div>

                      <div className="retailer__dtls mb-4">
                        <p>
                          {" "}
                          {rowDetails.DealerName
                            ? rowDetails.DealerName
                            : null}{" "}
                        </p>
                        <a href={`mailto:${rowDetails.DealerEmail}`}>
                          {rowDetails.DealerEmail
                            ? rowDetails.DealerEmail
                            : null}
                        </a>
                        <p>
                          {rowDetails.DealerPhone
                            ? rowDetails.DealerPhone
                            : null}
                        </p>
                        <span
                          className="linkText"
                          onClick={() => openInNewTab()}
                        >
                          {" "}
                          {rowDetails.website}
                        </span>
                        <hr />
                      </div>
                    </div>
                  </Spin>
                </div>
                <div className="col-lg-12">
                  <Modal
                    className="modalretailerprof__section"
                    centered
                    visible={visibleAll}
                    onOk={() => setVisibleAll(false)}
                    onCancel={() => setVisibleAll(false)}
                    footer={[
                      <Button
                        key="back"
                        onClick={handleCancelWarning}
                        disabled={updateFlagLoading}
                      >
                        {t("No")}
                      </Button>,
                      <Button
                        key="submit"
                        type="primary"
                        onClick={handleSaveUpdateAll}
                        loading={updateFlagLoading}
                        disabled={updateFlagLoading}
                      >
                        {t("Yes")}
                      </Button>,
                    ]}
                  >
                    <div className="col-lg-12">
                      <div className="modal__body">
                        <div className="col-lg-12">
                          <div className="form__fields border-0 p-0">
                            <div className="row">
                              <div className="col-lg-12">
                                <span>
                                  Warning: By Choosing {t("Yes")} you are
                                  confirming that you would like to{" "}
                                  {checked ? "ACTIVATE" : "DEACTIVATE"} ALL of
                                  your products from this Jewelry Vendor.
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Modal>

                  <Modal
                    title={
                      page == "RetailerAffirmation"
                        ? t("Retailer Affirmation")
                        : t("Send Email")
                    }
                    visible={isModalSendInvitationVisible}
                    className="forgot__password"
                    onCancel={handleSendInvitationModalCancel}
                    footer={[
                      //
                      <div
                        className={
                          page == "RetailerAffirmation" ? "d-block" : "d-none"
                        }
                      >
                        <Button
                          key="submit"
                          className={
                            checkbox == "" ? "disabled-btn" : "primary-btn"
                          }
                          disabled={checkbox == "" ? true : false}
                          onClick={
                            checkbox == "CurrentAuthorizedReseller"
                              ? handleShowEmailWindow
                              : checkbox == "NewAccountRequest"
                              ? handleNewAccountRequest
                              : handleCheckBoxValidation
                          }
                        >
                          {t("Submit")}
                        </Button>
                      </div>,
                      <div
                        className={page == "SendEmail" ? "d-block" : "d-none"}
                      >
                        <Button
                          className="primary-btn"
                          key="submit"
                          onClick={handleSendEmail}
                        >
                          {t("Send")}
                        </Button>
                      </div>,
                    ]}
                  >
                    <div className="form__fields p-0 border-0 mh-auto">
                      {page == "RetailerAffirmation" ? (
                        <div>
                          {category.map((item) => {
                            return (
                              <Fragment>
                                <div className="radio__block">
                                  <Checkbox
                                    key={item.value}
                                    onChange={handleCheckBoxChange}
                                    checked={item.value == checkbox}
                                    value={item.value}
                                  >
                                    <label> {t(item.label)} </label>
                                  </Checkbox>
                                </div>
                                <div>
                                  <p> {item.note} </p>
                                </div>
                              </Fragment>
                            );
                          })}
                        </div>
                      ) : (
                        <div className="editor__section">
                          <Spin spinning={emailLoading}>
                            <CKEditor
                              editor={ClassicEditor}
                              data={emailModalContent}
                              onReady={(editor) => {}}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setEmailModalContent(data);
                              }}
                            />
                          </Spin>
                        </div>
                      )}
                    </div>
                  </Modal>

                  {/* Inventory table modal */}

                  <Modal
                    title={t("Image Preview")}
                    centered
                    visible={visibleImagePreview}
                    onOk={() => setVisibleImagePreview(false)}
                    onCancel={() => setVisibleImagePreview(false)}
                    width={400}
                    footer={false}
                  >
                    <div className="form__fields mh-auto">
                      <img src={imagePath} className="img-fluid" />
                    </div>
                  </Modal>

                  {/* Appointment Schedule Modal */}

                  <Modal
                    className="emailTemplateEditorModal"
                    title={t("Send Email")}
                    centered
                    visible={visibleEmailModal}
                    onOk={() => setVisibleEmailModal(false)}
                    onCancel={() => setVisibleEmailModal(false)}
                    width={800}
                    hieght={600}
                    footer={[
                      <Button key="back" onClick={handleSendEmailCancel}>
                        {t("Cancel")}
                      </Button>,
                      <Button key="Save" onClick={handleSendEmailDetails}>
                        {t("Save")}
                      </Button>,
                    ]}
                  >
                    <div className="editor__section">
                      <Spin spinning={contentLoading}>
                        <CKEditor
                          editor={ClassicEditor}
                          data={contentAppData}
                          onReady={(editor) => {
                            // You can store the "editor" and use when it is needed.
                          }}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setContentAppData(data);
                          }}
                        />
                      </Spin>
                    </div>
                  </Modal>

                  <Modal
                    title={t("View Details")}
                    className="modalvdiamond__section"
                    centered
                    visible={visible}
                    onOk={() => setVisible(false)}
                    onCancel={() => setVisible(false)}
                    width={700}
                    footer={[
                      <Button key="back" onClick={handleCancel}>
                        {t("Cancel")}
                      </Button>,
                    ]}
                  >
                    <div className="col-lg-12">
                      <div className="modal__body">
                        <div className="col-lg-12">
                          <div className="form__fields border-0 p-0">
                            <div className="row">
                              <div className="col-lg-5 mt-4 text-center">
                                <div className="viewdtls__left">
                                  <img
                                    src={
                                      vendorProductDetail &&
                                      vendorProductDetail[0] &&
                                      vendorProductDetail[0].ImagePath
                                        ? vendorProductDetail[0].ImagePath
                                        : ""
                                    }
                                    className="img-fluid"
                                    alt="img-diamond"
                                  />
                                </div>
                              </div>

                              <div className="col-lg-7 mt-4">
                                <div className="info__div">
                                  <div className="manage__inventory">
                                    <p>
                                      <span className="head__txt">
                                        {" "}
                                        {t("Product Name")}:
                                      </span>
                                      <span className="val__txt">
                                        {vendorProductDetail &&
                                        vendorProductDetail[0] &&
                                        vendorProductDetail[0].ProductName
                                          ? vendorProductDetail[0].ProductName
                                          : ""}
                                      </span>
                                    </p>
                                    <p>
                                      <span className="head__txt">
                                        {" "}
                                        {t("Product Description")}:
                                      </span>
                                      <span className="val__txt">
                                        {vendorProductDetail &&
                                          vendorProductDetail[0] &&
                                          vendorProductDetail[0].ProductDesc
                                          ? new DOMParser()
                                            .parseFromString(vendorProductDetail[0].ProductDesc, "text/html")
                                            .body.textContent
                                            .replace(/\s+/g, " ")
                                            .trim()
                                          : ""}
                                      </span>
                                    </p>
                                    <p>
                                      <span className="head__txt">
                                        {" "}
                                        {t("Style")}#:
                                      </span>{" "}
                                      <span className="val__txt">
                                        {vendorProductDetail &&
                                        vendorProductDetail[0] &&
                                        vendorProductDetail[0].StyleNo
                                          ? vendorProductDetail[0].StyleNo
                                          : ""}
                                      </span>
                                    </p>
                                    <p>
                                      <span className="head__txt">
                                        {" "}
                                        {t("Collection")}:
                                      </span>
                                      <span className="val__txt">
                                        {vendorProductDetail &&
                                        vendorProductDetail[0] &&
                                        vendorProductDetail[0].Coll
                                          ? vendorProductDetail[0].Coll
                                          : ""}
                                      </span>
                                    </p>
                                    <p>
                                      <span className="head__txt">
                                        {" "}
                                        {t("Metal Type")}:
                                      </span>{" "}
                                      <span className="val__txt">
                                        {vendorProductDetail &&
                                        vendorProductDetail[0] &&
                                        vendorProductDetail[0].MetalType
                                          ? vendorProductDetail[0].MetalType
                                          : ""}
                                      </span>
                                    </p>
                                    <p>
                                      <span className="head__txt">
                                        {" "}
                                        {t("Metal Color")}:
                                      </span>{" "}
                                      <span className="val__txt">
                                        {vendorProductDetail &&
                                        vendorProductDetail[0] &&
                                        vendorProductDetail[0].MetalColor
                                          ? vendorProductDetail[0].MetalColor
                                          : ""}
                                      </span>
                                    </p>
                                    <p>
                                      <span className="head__txt">
                                        {" "}
                                        {t("MSRP Price")}:{" "}
                                      </span>{" "}
                                      <span className="val__txt">
                                        {(() => {
                                          const shouldHidePrice =
                                            checkHidePrice === "true" ||
                                            checkHidePrice === "1" ||
                                            checkHidePrice === 1;
                                          if (shouldHidePrice) {
                                            return " - ";
                                          }
                                          return vendorProductDetail &&
                                            vendorProductDetail[0] &&
                                            vendorProductDetail[0].MSRP &&
                                            vendorProductDetail[0].MSRP !==
                                              "0" &&
                                            vendorProductDetail[0].MSRP !==
                                              "N/A"
                                            ? `${(vendorProductDetail[0].Currency === "CHF" || vendorProductDetail[0].Currency === "SEK")
                                              ? vendorProductDetail[0].CurrenySymbol + " " + vendorProductDetail[0].MSRP
                                              : vendorProductDetail[0].Currency + vendorProductDetail[0].CurrenySymbol + " " + vendorProductDetail[0].MSRP}`
                                            : " - ";
                                        })()}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Modal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ManageInventory;
